export const envTypes = {
  TEST: "TEST",
  PRODUCTION: "PRODUCTION",
};
